<template>
  <div>
    <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
      {{ snackbar_message }}
    </v-snackbar>

    <v-card flat class="mt-1 mb-1">
      <v-card-text>
        <h3 class="primary--text">Rechecher un évènement par filtre</h3>
        <v-form ref="form" lazy-validation @submit.prevent="searchByFiltre()">
          <v-container grid-list-md text-xs-center>
            <v-layout align-center justify-end fill-height>

              <v-btn rounded color="primary" class="text-capitalize mr-2" v-if="$can('export events')">
                <export-excel :data="coming_events.data" name="Evenements_a_réaliser.xls" :export-fields="json_fields">
                  Exporter
                  <v-icon right>mdi-share-outline</v-icon>
                </export-excel>
              </v-btn>

              <v-btn rounded color="primary" class="text-capitalize" v-if="$can('export events')"
                @click="printGlobale()">
                Exporter Global
                <v-icon right>mdi-share-outline</v-icon>
              </v-btn>

              <v-btn rounded color="primary" class="ml-2 text-capitalize" @click="importEvent()">
                Importer des evènements
                <v-icon right>mdi-database-import</v-icon>

              </v-btn>
            </v-layout>
            <v-layout row wrap>
              <v-row>
                <v-col cols="12" md="2">
                  <v-select v-model="search_domain" :items="domains" item-text="name" item-value="id" clearable solo
                    label="Domaine" @change="reloadData($event)"></v-select>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select v-model="search_department" :items="liste_dep" item-text="name" item-value="id" clearable
                    solo label="Département" @change="reloadData($event)"></v-select>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select v-model="search_municipality" :items="liste_municipalities" item-text="name" item-value="id"
                    clearable solo label="Commune" @change="reloadData($event)"></v-select>
                </v-col>

                <v-col cols="12" md="3">
                  <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
                    <template v-slot:activator="{ on }">
                      <v-text-field :value="startDateMoment" @click:clear="removeStartDate()" clearable label="De"
                        readonly v-on="on" solo prepend-icon="mdi-calendar"></v-text-field>
                    </template>
                    <v-date-picker v-model="start_date" @change="reloadData(1)">
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="3">
                  <v-menu v-model="menu2" :close-on-content-click="false" max-width="290">
                    <template v-slot:activator="{ on }">
                      <v-text-field :value="endDateMoment" @click:clear="removeEndDate()" clearable label="A" readonly
                        v-on="on" solo prepend-icon="mdi-calendar"></v-text-field>
                    </template>
                    <v-date-picker v-model="end_date" @change="reloadData(2)">
                    </v-date-picker>
                  </v-menu>
                </v-col>

              </v-row>

              <v-select v-model="search_sae" :items="sae_list" item-text="name" item-value="id" clearable solo
                label="SAE" @change="reloadData($event)" class="mr-2"></v-select>

              <v-text-field v-model="search_word" @input="searchEvent($event)" label="Filter par nom, type" solo
                class="">

              </v-text-field>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>

    <v-container grid-list-md>
      <div class="text-center" v-if="loader">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <div v-if="coming_events.data && coming_events.data.length == 0" class="text-center">
          <h4>Aucun évènement à réaliser</h4>
        </div>

        <v-layout row wrap v-else>
          <v-row>
            <v-col col="12" md="4" v-for="(one_event, index) in coming_events.data" :key="one_event.id" xs4
              class="mb-3">
              <v-card>
                <v-card-title>
                  <v-layout row>
                    <v-flex xs11 md11>
                      <a class="titreEvent" href="#" @click="showEvent(one_event.id)">
                        {{
                          one_event.name.length < 70 ? one_event.name : one_event.name.substring(0, 70) + " ..." }}</a>
                    </v-flex>

                    <v-flex text-right xs1 md1>
                      <v-menu bottom left transition="slide-y-transition">
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="
                            editEvent(one_event.id)
                            ">
                            <v-list-item-action>
                              <v-btn fab icon dark small color="orange" v-if="$can(
                                'edit events'
                              )
                              ">
                                <v-icon>mdi-pencil-outline</v-icon>
                              </v-btn>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>Editer</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item @click="
                            isDeletingEvent(
                              one_event,
                              index
                            )
                            ">
                            <v-list-item-action>
                              <v-btn fab icon dark small color="error" v-if="$can(
                                'delete events'
                              )
                              ">
                                <v-icon>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>Supprimer</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-flex>

                    <v-flex x12>
                      <h5 class="text-justify">
                        <span left class="">Date de début :
                        </span>
                        <span text-right>
                          <a>{{
                            one_event.event_date
                            | moment("D MMMM YYYY")
                          }}
                            {{
                              one_event.event_time
                              | moment("HH:mm:ss")
                            }}</a>
                        </span>
                      </h5>
                      <h5 class="text-justify font-weight-bold">
                        <span class="">Date de fin:
                        </span>
                        <span>
                          <a>
                            {{
                              one_event.event_date_end
                              | moment("D MMMM YYYY")
                            }}
                          </a>
                        </span>

                      </h5>
                    </v-flex>
                  </v-layout>
                </v-card-title>

                <v-card-text>
                  <div class="mb-1">
                    <i if="one_event.event_type">
                      {{
                        one_event.event_type.name.length < 80 ? one_event.event_type.name :
                          one_event.event_type.name.substring(0, 80) + " ..." }} </i>
                  </div>

                  <div>{{ one_event.type }}</div>

                  <div class="text-center mt-3" v-if="one_event.domain">
                    <v-chip>{{
                      one_event.domain.name
                    }}</v-chip>
                  </div>

                  <div class="text-center mt-3">
                    <v-icon>mdi-map-marker</v-icon>
                    {{
                      one_event.municipality
                        ? one_event.municipality.name
                        : ""
                    }},
                    {{ one_event.place }}
                    <br />

                    <div v-if="one_event.users && one_event.users.length" class="text-center mt-3">
                      <h2 class="bolder-text text-black-50">
                        <span left> Créé par:</span>

                        <span>
                          <a>
                            {{ one_event["users"][0] && one_event["users"][0]['profile'] ?
                              one_event["users"][0]["profile"][
                              "full_name"
                              ] : one_event["users"][0]['username']
                            }}
                          </a>
                        </span>
                        <br />
                        <span left> Le:</span>
                        <span>
                          <a>
                            {{
                              one_event.created_at
                              | moment("D MMMM YYYY")
                            }}
                          </a>
                        </span>

                      </h2>
                    </div>
                    <div v-if="one_event.sae_type" pill class="text-center mt-3">
                      <h2 class="bolder-text text-black-200">
                        <span left> SAE :</span>

                        <span pill text-color="primary">
                          <a>{{
                            one_event.sae_type.name
                          }}</a>

                        </span>
                      </h2>



                    </div>

                    <v-chip pill color="primary" text-color="white" class="mt-3">
                      <v-avatar left color="primary darken-2">
                        {{ one_event.new_actors_count }}
                      </v-avatar>
                      participants
                    </v-chip>
                  </div>


                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

        </v-layout>
        <div class="text-center" v-if="coming_events.data && coming_events.data.length > 0">
          <v-pagination v-model="pagination.current" :length="pagination.total" @input="onPageChange"
            circle></v-pagination>
        </div>
      </div>
    </v-container>

    <v-layout row justify-center>
      <v-dialog v-model="dialog_deletion" persistent hide-overlay max-width="550">
        <delete-with-password v-if="item" @cancel="dialog_deletion = false" @deleteItem="delEvent" :item="item"
          message="Etes - vous sûr de vouloir supprimer cet évènement ?" title="Suppression"></delete-with-password>
      </v-dialog>
    </v-layout>
    <div class="text-center">
      <v-dialog v-model="dialog_dowload" :scrim="false" persistent hide-overlay max-width="290">
        <v-card>
          <v-card-title class="m-4">
            Téléchargement en cours...
            <v-progress-linear indeterminate color="primary" class="mb-0"></v-progress-linear>
          </v-card-title>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Permissions from '~/mixins/Permissions'
import DeleteWithPassword from '~/components/DeleteWithPassword'

export default {
  name: 'event-coming',
  components: {
    DeleteWithPassword
  },
  mixins: [Permissions],
  data() {
    return {
      snackbar: false,
      snackbar_message: '',
      snackbar_timeout: 5000,
      snackbar_color: '',
      json_fields: {
        "Nom de l'évènement": 'name',
        "Organisateur de l'évènement": 'profile_names',
        'Nom de SAE': 'sae_type.name',
        'Nom du staff ACMA3 impliqué': 'staff_name',
        "Objectifs de l'événement": 'objective',
        "Type de l'évènement": 'event_type.name',
        'Chaine de valeur': 'value_chain',
        'Domaine de Résultat': 'domain.name',
        'thematique': 'thematic.name',
        'Date de debut': 'event_date',
        'Date de fin': 'event_date_end',
        cle_evenement: 'id',
        Pays: 'country.name',
        Département: 'department.name',
        Commune: 'municipality.name',
        Arrondissement: 'district.name',
        Village: 'town.name',
        Date: 'created_at',
        Lieu: 'place'
      },

      pagination: {
        current: 1,
        total: 0
      },
      dialog_deletion: false,
      deletion_id: null,
      deletion_index: null,

      search_domain: null,
      search_department: null,
      search_municipality: null,
      search_sae: null,
      search_word: null,
      start_date: null,
      end_date: null,
      menu1: false,
      menu2: false,
      search_ongoing: false,
      loader: false,
      dialog_dowload: false,
      item: null,
      liste_municipalities: [],
      sae_list: [],
      coming_events: [],
      uri: '/api/events?include=municipality,thematic,domain,saeType,users,country,department,district,town,chains,user_level_one,user_level_two&event_type=coming&page='
    }
  },

  computed: {
    new_event_added() {
      return this.$route.params.new_event_added
    },
    event_deleted() {
      return this.$route.params.event_deleted
    },
    event_updated() {
      return this.$route.params.event_updated
    },

    domains() {
      return this.$store.getters.getDomains
    },

    startDateMoment() {
      return this.start_date
        ? this.$moment(this.start_date).format('D MMMM YYYY')
        : ''
    },

    endDateMoment() {
      return this.end_date
        ? this.$moment(this.end_date).format('D MMMM YYYY')
        : ''
    },

    liste_dep() {
      return this.$store.getters.departments
    }

  },

  created() {
    this.$checkPermission('view events')
    this.comingEvents()
    this.fetchDomains()
    this.fetchDepartments()
    this.fetchUtils()
    this.fetchSaes()
    this.fetchMunicipalities()
  },

  methods: {

    async importEvent() {
      this.$router.push({ name: 'events.import' })
    },

    async searchEvent(event) {
      const uri = '/api/events?include=municipality,domain,saeType,users,country,department,district,town,chains,user_level_one,user_level_two&event_type=coming&page=' + this.pagination.current + '&search=' + event

      this.makeRequete(uri)
    },
    async comingEvents() {
      this.uri += this.pagination.current
      this.makeRequete(this.uri)
    },
    async fetchUtils() {

      await this.$store.dispatch('loadLocaleFr', this.$moment)

      if (this.new_event_added) {
        this.snackbar = true
        this.snackbar_color = 'success'
        this.snackbar_message =
          'Nouvel évènement enregistré avec succès !'
        // this.new_event_added = null
      } else if (this.event_deleted) {
        this.snackbar = true
        this.snackbar_color = 'success'
        this.snackbar_message = 'Evènement supprimé !'
        // this.event_deleted = null
      } else if (this.event_updated) {
        this.snackbar = true
        this.snackbar_color = 'success'
        this.snackbar_message = 'Evènement mis à jour !'
        // this.event_updated = null
      }
    },
    async fetchDomains() {
      this.loader = true
      await this.$store.dispatch('loadDomains').then(() => {
        this.loader = false
      })
    },
    async fetchMunicipalities() {
      this.loader = true
      try {
        this.liste_municipalities = (await axios.get('/municipalities?include=department')).data
      } catch (e) {
        console.log(e)
      }
    },
    async fetchSaes() {
      this.loader = true
      try {
        this.sae_list = (await axios.get('/api/sae_types')).data
      } catch (e) {
        console.log(e)

      }
    },
    async fetchDepartments() {
      this.loader = true
      await this.$store.dispatch('fetchDepartments').then(() => {
        this.loader = false
      })
    },
    async onPageChange() {
      if (this.search_ongoing) {
        this.reloadData(50)
      } else {
        const uri = '/api/events?include=municipality,domain,saeType,users,country,department,district,town,chains,user_level_one,user_level_two&event_type=coming&page=' + this.pagination.current
        this.makeRequete(uri)
        this.search_ongoing = false
      }
    },

    showEvent(id) {
      this.$router.push({ name: 'events.show', params: { Pid: id } })
    },

    isDeletingEvent(value, index) {
      this.item = value.name
      this.deletion_id = value.id
      this.deletion_index = index
      this.dialog_deletion = true
    },

    delEvent() {
      if (this.deletion_id) {
        const uri = '/api/events/' + this.deletion_id
        // const route_obj = this.$router

        const objet = this

        axios
          .delete(uri)
          .then(response => {
            // objet.$forceUpdate();
            objet.dialog_deletion = false
            objet.snackbar = true
            objet.snackbar_color = 'success'
            objet.snackbar_message = 'Evènement supprimé !'
            this.reloadData()
          })
          .catch(err => {
            console.log('Event deletion error ', err)
          })
      }
    },

    async reloadData(value) {
      this.search_ongoing = true
      this.loader = true
      let uri =
        '/api/events?event_type=coming&include=municipality,domain,saeType,users,country,department,district,town,chains,user_level_one,user_level_two&page=' +
        this.pagination.current

      if (this.search_word) {
        uri += "&search=" + this.search_word;

      }
      if (this.start_date) {
        this.menu1 = false;

        uri += "&start_date=" + this.start_date;
      }

      if (this.end_date) {
        this.menu2 = false;
        uri += "&end_date=" + this.end_date;
      }

      if (
        this.search_domain
      ) {
        uri += '&filter[domain_id]=' + this.search_domain
      }
      if (
        this.search_department
      ) {
        uri += '&filter[department_id]=' + this.search_department
        this.liste_municipalities = (await axios.get('/municipalities?include=department&filter[department_id]=' + this.search_department)).data
      }

      if (
        this.search_municipality
      ) {
        uri += '&filter[municipality_id]=' + this.search_municipality
      }
      if (
        this.search_sae
      ) {
        uri += '&filter[sae_type_id]=' + this.search_sae
      }

      this.makeRequete(uri)

      this.loader = false
    },
    editEvent(id) {
      const payload = {};
      payload.event_id = id;
      payload.router = this.$router;

      this.$store.dispatch("loadEditableEvent", payload);
    },
    async makeRequete(uri) {
      const results = (await axios.get(uri)).data

      if (results.data) {
        for (const event of results.data) {
          const usersWithProfile = event.users.filter(user => user.profile !== null && user.profile !== undefined)

          if (usersWithProfile.length > 0) {
            event.profile_names = usersWithProfile.map(user => user.profile.full_name).join(', ')
          }
          event.value_chain = event.chains
            .map(chain => chain.name)
            .join(', ')
        }
        this.coming_events = results

        this.pagination.current = this.coming_events.current_page
        this.pagination.total = this.coming_events.last_page
      }
    },
    searchByFiltre() {
      if (
        this.search.domain != null ||
        this.search.place != null ||
        this.start_date != null ||
        this.end_date != null
      ) {
        this.search_ongoing = true

        this.search.start_date = this.start_date
        this.search.end_date = this.end_date
        const page = this.pagination.current
        this.search.page = page
        this.search.type = 'coming'
      } else {
        this.search_ongoing = false
        this.snackbar = true
        this.snackbar_color = 'warning'
        this.snackbar_message =
          'Veuillez remplir au moins un élément du filtre'
      }
    },

    async printGlobale() {

      this.dialog_dowload = true

      let uri = '/api/event-participents'

      uri += "?event_type=coming";
      if (this.start_date) {
        this.menu1 = false;

        uri += "&start_date=" + this.start_date;
      }

      if (this.end_date) {
        this.menu2 = false;
        uri += "&end_date=" + this.end_date;
      }

      if (
        this.search_domain
      ) {
        uri += '&domain_id=' + this.search_domain
      }
      if (
        this.search_department
      ) {
        uri += '&department_id=' + this.search_department
        this.liste_municipalities = (await axios.get('/municipalities?include=department&filter[department_id]=' + this.search_department)).data
      }

      if (
        this.search_municipality
      ) {
        uri += '&municipality_id=' + this.search_municipality
      }
      if (
        this.search_sae
      ) {
        uri += '&sae_type_id=' + this.search_sae
      }
      if (this.search_word) {
        uri += "&search=" + this.search_word;

      }      
      const objet = this;
      await axios
        .get(uri)
        .then((response) => {

          objet.dialog_deletion = false;
          objet.snackbar = true;
          objet.snackbar_color = "success";
          objet.snackbar_message = response.data.message;
          this.reloadData();
        })
        .catch((err) => {
          console.log("Export error ", err);
        });

      this.dialog_dowload = false
    },
    removeStartDate() {
      this.start_date = null
      this.reloadData()
    },
    removeEndDate() {
      this.end_date = null
      this.reloadData()
    }

  }
}
</script>

<style scoped>
.gris-couleur {
  background-color: #e0e0e0;
}

.white-couleur {
  color: white;
}

.v-card__title {
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: normal;
  line-height: 1.5rem;
}

.titreEvent {
  text-decoration: none;
}

.titreEvent:hover {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/events/index-coming.vue